import Box from '@mui/material/Box';
import {DataGridPro} from '@mui/x-data-grid-pro';
import { GridToolbarContainer, GridToolbarFilterButton, GridToolbarQuickFilter } from '@mui/x-data-grid-pro';
import { Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import LoadListMapListBody from './LoadListMapListBody';

export default function AssetsList(props){
    //console.debug("RTS Break AssetsList");

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));


    function MapListToolbar(props) {
        return(
            <GridToolbarContainer {...props} sx={{display:'flex', width:'100%'}}>
                <Box sx={{display:'flex', width:'100%', justifyContent:'right', alignItems:'center', mr:2}}>
                    <Typography variant='caption' sx={{mr:1}}>Pin #:</Typography>
                    <Box>
                        <GridToolbarQuickFilter />
                    </Box>
                </Box>
            </GridToolbarContainer>
        );
    }


    const columns = [
        {
            field: 'displayVal', 
            headerName: "", 
            description:"Reel", 
            flex:10,
            renderCell: (cellValues) => {
                    return (
                        <LoadListMapListBody data={cellValues.row} />
                    );
            },
            align:"center",
            sortable:false,
            filterable:false,
            hideable:false,
            disableColumnMenu:true                       
        },
        {
            field: 'childIdx', 
            headerName: "IndexVal", 
            description:"IndexVal", 
            sortable:true,
            filterable:true,
            disableColumnMenu:false,
            type:"number",
        },        
    ];


    function getVisibilityModel(){
        if(smallForm){
            return {childIdx:false }
        }
        else{
            return {childIdx:false }
        }
    }


    function getDensity(){
        if(smallForm){
            return "comfortable";
        }
        else{
            return "standard";
        }
    }


    return (
        <>
        <Box sx={{width:'100%', height:'100%', minHeight:'400px', pb:1, mt:11}}>
            <DataGridPro 
                pagination={true}
                slots={{toolbar: MapListToolbar}}
                slotProps={{
                    toolbar:{
                        showQuickFilter:true,
                    }
                }}
                rows={props.data} 
                columns={columns} 
                getRowId={row => row.idGuid} 
                getRowHeight={() => 'auto'}
                columnHeaderHeight={0}
                initialState={{
                    columns:{
                        columnVisibilityModel: getVisibilityModel()
                    },
                    pagination: { paginationModel: { pageSize: 50 } },
                    density: getDensity(),
                    filter: {
                        filterModel:{
                            quickFilterExcludeHiddenColumns: false,
                            items: [],
                        }
                    } 
                }}
                sx={{ '&, [class^=MuiDataGrid]': { border: 'none' } }}                   
            />
        </Box>
        </>        
    );
}
